<style lang="sass">
.ds-input-group {
  font-size: 0;
}

.ds-input-group input {
  border-radius: 0;
}

.ds-input-group .btn {
  height: 34px;
}

.ds-input-group .btn:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  margin-right: -1px;
}

.ds-input-group .btn:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  margin-left: -1px;
}
</style>


<template>
<div class="date-selector">
  <div class="form-group">
    <button type="button" class="btn btn-default" @click="toToday()">本日の予約</button>
  </div>
  <div class="form-group ds-input-group">
    <button type="button" class="btn btn-default" @click="addDays(-1)">
      <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
    </button>
    <datepicker
        :value.sync="date"
        date-format="MM/DD (dd)"
        :width="90"
    ></datepicker>
    <button type="button" class="btn btn-default" @click="addDays(1)">
      <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
    </button>
  </div>
</div>
</template>


<script>
import moment from 'moment'

export default {
  name: 'date-selector',
  props: {
    date: {
      type: String,
      twoWay: true,
      default: null,
    },
  },
  methods: {
    toToday() {
      this.date = moment().startOf('day').format('YYYY-MM-DD')
    },
    addDays(n) {
      this.date = moment(this.date).add(n, 'days').format('YYYY-MM-DD')
    }
  },
  components: {
    datepicker: require('ui/datepicker.vue'),
  },
}
</script>



// WEBPACK FOOTER //
// date-selector.vue?44525724